export default __webpack_public_path__ + "static/media/goal.68ba0530.svg";